import { FC, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const AgentTourWidget = lazy(() => import('src/components/common/AgentTourWidget'));

const COVER_IMAGE = '/images/cover-optimized.jpg';

const Cover: FC = () => {
  const { t }: any = useTranslation();
  const lcpImageProps = { fetchPriority: 'high' as const };

  return (
    <section className="tours-page-container-cover">
      <img
        src={COVER_IMAGE}
        srcSet={`${COVER_IMAGE} 1400w, /images/cover.jpg 3200w`}
        sizes="100vw"
        alt="Travel experience"
        className="cover-img"
        width="1400"
        height="1050"
        loading="eager"
        decoding="async"
        {...lcpImageProps}
      />
      <div className="cover-overlay" />
      <div className="cover-content">
        <span className="cover-kicker">{t('homepageKicker')}</span>
        <h1>{t('homepageHeroTitle')}</h1>
        <p>{t('homepageHeroSubtitle')}</p>
        <div className="cover-ai-widget">
          <Suspense fallback={<div className="cover-ai-widget-placeholder" />}>
            <AgentTourWidget variant="embedded" />
          </Suspense>
        </div>
        <div className="cover-trust-list">
          <span>{t('homepageFastBooking')}</span>
          <span>{t('homepageCuratedTours')}</span>
          <span>{t('homepageLocalSupport')}</span>
        </div>
      </div>
    </section>
  );
};

export default Cover;
